import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/* API helper */
import { api } from "../api";

/* CSS */
import AuthHeader from '../components/layout/AuthHeader';
import shared from '../styles/shared.module.css';
import styles from "./SignUpPage.module.css";

/* Authentication component */
import OAuth from "../components/auth/OAuth";

/* Icons */
import exclamation from '../assets/icons/exclamation_red.svg';

const SignUpPage = () => {

    const navigate = useNavigate();

    // Save the original destination to 'next' before redirecting
    const location = useLocation();
    const next = new URLSearchParams(location.search).get('next');

    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [signupError, setSignupError] = useState("");

    const handleSignup = async () => {
        try {
            setIsLoading(true);
            await api.post('/auth/check-email', { email });
            navigate('/checkemail', { state: { email, next } });
        } catch (err) {
            console.error("Error signing up: ", err);
            setSignupError(err.message || "Error signing up. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {/* Header */}
            <AuthHeader showCancel={false} />

            {/* Body */}
            <div className={shared.authBody}>
                {/* Greetings title */}
                <div className={shared.authTitleWrapper}>
                    <div className={shared.authTitle}>
                        Create your TravelBuddy account
                    </div>
                    <div className={shared.authSubtitleWrapper}>
                        <div className={shared.authSubTitleText}>
                            Already have an account?
                        </div>
                        <div
                            className={shared.authSubTitleToggle}
                            onClick={() => navigate('/login')}
                        >
                            Log in
                        </div>
                    </div>
                </div>

                {/* Main input */}
                <div className={shared.authBodyInput}>

                    <form noValidate onSubmit={(e) => { e.preventDefault(); handleSignup() }}>
                        {/* Email */}
                        <div className={shared.authField}>
                            <div className={shared.authFieldLabel}>
                                First, enter your email address
                            </div>

                            <input
                                type="email"
                                name="email"
                                autoComplete="email"
                                className={shared.authFieldInput}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        {/* Signup error */}
                        {signupError && (
                            <div className={styles.signupError}>
                                <img
                                    src={exclamation}
                                    alt="Invalid email"
                                    className={styles.signupErrorIcon}
                                />
                                <div className={styles.signupErrorMessage}>
                                    {signupError}
                                </div>
                            </div>
                        )}

                        <button
                            type="submit"
                            className={`${shared.authButton} ${isLoading ? shared.buttonLoading : ''}`}
                        >
                            <div className={shared.buttonContent}>
                                {isLoading ? "Hang on tight..." : "Next"}
                                {isLoading && <span className={shared.spinner}></span>}
                            </div>
                        </button>

                        {/* OAuth */}
                        <OAuth dividerText={"Or sign up with"} next={next} />
                    </form>
                </div>

                {/* Legal text */}
                <div className={styles.legalText}>
                    By registering, you accept our <a href="/terms" target="_blank" rel="noopener noreferrer" className={styles.legalLink}>Terms of Use</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer" className={styles.legalLink}>Privacy Policy</a>
                </div>

            </div>
        </>
    );
};

export default SignUpPage;